import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log('process index controller connected')
    localStorage.removeItem('paperworkProcessReferences');
    console.log('Cleared process review list from local storage on index load');
    // Remember the list URL (with its current search/filters) so the process
    // header's "back to list" button can return here with the same view.
    try {
      localStorage.setItem('paperworkProcessListUrl', window.location.href);
    } catch (error) {
      console.error('Error storing process list URL in local storage:', error);
    }
  }

  startTriage(event) {
    const processReferences = Array.from(document.querySelectorAll('[data-process-reference]')).map(el => el.dataset.processReference)
    localStorage.setItem('paperworkProcessReferences', JSON.stringify(processReferences))
    
    const firstProcess = processReferences[0]
    if (firstProcess) {
      // prevent default link navigation
      event.preventDefault()
      window.location.href = `/processes/${firstProcess}`
    }
  }
}
